export function BicycleIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_11611_692"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="14.8584" height="14.8584" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_11611_692)">
        <path
          d="M3.0955 13.6203C2.23908 13.6203 1.50906 13.3184 0.905434 12.7148C0.301811 12.1112 0 11.3812 0 10.5248C0 9.66834 0.301811 8.93832 0.905434 8.33469C1.50906 7.73107 2.23908 7.42926 3.0955 7.42926C3.95192 7.42926 4.68194 7.73107 5.28557 8.33469C5.88919 8.93832 6.191 9.66834 6.191 10.5248C6.191 11.3812 5.88919 12.1112 5.28557 12.7148C4.68194 13.3184 3.95192 13.6203 3.0955 13.6203ZM4.41109 11.8403C4.77223 11.4792 4.9528 11.0407 4.9528 10.5248C4.9528 10.0088 4.77223 9.57031 4.41109 9.20917C4.04995 8.84803 3.61142 8.66746 3.0955 8.66746C2.57958 8.66746 2.14105 8.84803 1.77991 9.20917C1.41877 9.57031 1.2382 10.0088 1.2382 10.5248C1.2382 11.0407 1.41877 11.4792 1.77991 11.8403C2.14105 12.2015 2.57958 12.3821 3.0955 12.3821C3.61142 12.3821 4.04995 12.2015 4.41109 11.8403ZM6.8101 11.763V8.66746L4.82898 6.93398C4.70516 6.82048 4.61229 6.68892 4.55038 6.5393C4.48847 6.38969 4.45752 6.23233 4.45752 6.06724C4.45752 5.90215 4.49105 5.74479 4.55812 5.59518C4.62519 5.44556 4.71548 5.314 4.82898 5.2005L6.56246 3.46702C6.68628 3.3432 6.82816 3.25034 6.98809 3.18843C7.14802 3.12652 7.3157 3.09556 7.49111 3.09556C7.66652 3.09556 7.83419 3.12652 7.99413 3.18843C8.15406 3.25034 8.29594 3.3432 8.41976 3.46702L9.59605 4.64331C9.88496 4.93222 10.2151 5.15923 10.5866 5.32432C10.9581 5.48941 11.3502 5.57196 11.7629 5.57196V6.81016C11.1748 6.81016 10.615 6.69666 10.0836 6.46966C9.5522 6.24265 9.08013 5.92278 8.6674 5.51005L8.17212 5.01477L6.68628 6.50061L8.0483 7.92454V11.763H6.8101ZM8.72157 3.04139C8.47909 2.79891 8.35785 2.50742 8.35785 2.16691C8.35785 1.82641 8.47909 1.53491 8.72157 1.29243C8.96405 1.04995 9.25554 0.928711 9.59605 0.928711C9.93655 0.928711 10.228 1.04995 10.4705 1.29243C10.713 1.53491 10.8342 1.82641 10.8342 2.16691C10.8342 2.50742 10.713 2.79891 10.4705 3.04139C10.228 3.28387 9.93655 3.40511 9.59605 3.40511C9.25554 3.40511 8.96405 3.28387 8.72157 3.04139ZM11.7629 13.6203C10.9065 13.6203 10.1765 13.3184 9.57283 12.7148C8.96921 12.1112 8.6674 11.3812 8.6674 10.5248C8.6674 9.66834 8.96921 8.93832 9.57283 8.33469C10.1765 7.73107 10.9065 7.42926 11.7629 7.42926C12.6193 7.42926 13.3493 7.73107 13.953 8.33469C14.5566 8.93832 14.8584 9.66834 14.8584 10.5248C14.8584 11.3812 14.5566 12.1112 13.953 12.7148C13.3493 13.3184 12.6193 13.6203 11.7629 13.6203ZM13.0785 11.8403C13.4396 11.4792 13.6202 11.0407 13.6202 10.5248C13.6202 10.0088 13.4396 9.57031 13.0785 9.20917C12.7173 8.84803 12.2788 8.66746 11.7629 8.66746C11.247 8.66746 10.8085 8.84803 10.4473 9.20917C10.0862 9.57031 9.9056 10.0088 9.9056 10.5248C9.9056 11.0407 10.0862 11.4792 10.4473 11.8403C10.8085 12.2015 11.247 12.3821 11.7629 12.3821C12.2788 12.3821 12.7173 12.2015 13.0785 11.8403Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function IconPin({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M6.919 15.5957C8.71231 13.9903 10.0846 12.4505 11.036 10.9762C11.9873 9.50186 12.463 8.21058 12.463 7.10233C12.463 5.43125 11.9321 4.05747 10.8703 2.981C9.80849 1.90453 8.49139 1.36629 6.919 1.36629C5.34661 1.36629 4.02951 1.90453 2.96771 2.981C1.9059 4.05747 1.375 5.43125 1.375 7.10233C1.375 8.21058 1.85067 9.50186 2.80202 10.9762C3.75337 12.4505 5.12569 13.9903 6.919 15.5957ZM6.919 16.9036C6.7404 16.9036 6.56181 16.8728 6.38321 16.8112C6.20446 16.7495 6.04282 16.654 5.89829 16.5247C5.07574 15.7667 4.30597 14.986 3.58898 14.1827C2.87215 13.3795 2.24904 12.5766 1.71967 11.7739C1.19014 10.9712 0.771146 10.1756 0.462688 9.38713C0.154229 8.59849 0 7.83689 0 7.10233C0 4.98697 0.684215 3.27441 2.05265 1.96465C3.42123 0.654881 5.04335 0 6.919 0C8.79465 0 10.4168 0.654881 11.7854 1.96465C13.1538 3.27441 13.838 4.98697 13.838 7.10233C13.838 7.83689 13.6838 8.59696 13.3753 9.38254C13.0669 10.1683 12.6494 10.9639 12.1229 11.7695C11.5963 12.5751 10.9746 13.3781 10.2577 14.1783C9.5409 14.9787 8.77112 15.7579 7.94842 16.5158C7.80603 16.6451 7.64416 16.742 7.46281 16.8066C7.28162 16.8713 7.10035 16.9036 6.919 16.9036ZM6.9206 8.58481C7.37665 8.58481 7.76653 8.42241 8.09027 8.0976C8.41416 7.7728 8.5761 7.38237 8.5761 6.92633C8.5761 6.47029 8.4137 6.08033 8.0889 5.75644C7.76409 5.4327 7.37359 5.27083 6.9174 5.27083C6.46135 5.27083 6.07147 5.43324 5.74773 5.75804C5.42384 6.08285 5.2619 6.47335 5.2619 6.92954C5.2619 7.38558 5.4243 7.77547 5.7491 8.09921C6.07391 8.42295 6.46441 8.58481 6.9206 8.58481Z"
        fill="#BABABA"
      />
    </svg>
  );
}

export function IconClock({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className={className}>
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm.75 5h-1.5v6l5 3 .75-1.23-4.25-2.52V7z" />
    </svg>
  );
}

export function IconAlarm({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M7.03467 6.33217V3.70133C7.03467 3.55944 6.98678 3.44067 6.891 3.345C6.79533 3.24922 6.67656 3.20133 6.53467 3.20133C6.39278 3.20133 6.274 3.24922 6.17833 3.345C6.08256 3.44067 6.03467 3.55944 6.03467 3.70133V6.486C6.03467 6.56633 6.04922 6.64283 6.07833 6.7155C6.10733 6.78806 6.15306 6.85556 6.2155 6.918L8.1655 8.868C8.25772 8.96033 8.37372 9.00756 8.5135 9.00967C8.65328 9.01178 8.77144 8.96456 8.868 8.868C8.96456 8.77144 9.01283 8.65433 9.01283 8.51667C9.01283 8.37911 8.96456 8.26206 8.868 8.1655L7.03467 6.33217ZM6.53467 12.2013C5.74833 12.2013 5.01161 12.0526 4.3245 11.7552C3.63728 11.4577 3.03811 11.0534 2.527 10.5423C2.01589 10.0312 1.61161 9.43206 1.31417 8.74483C1.01672 8.05772 0.868 7.321 0.868 6.53467C0.868 5.74833 1.01672 5.01161 1.31417 4.3245C1.61161 3.63728 2.01589 3.03811 2.527 2.527C3.03811 2.01589 3.63728 1.61161 4.3245 1.31417C5.01161 1.01672 5.74833 0.868 6.53467 0.868C7.321 0.868 8.05772 1.01672 8.74483 1.31417C9.43206 1.61161 10.0312 2.01589 10.5423 2.527C11.0534 3.03811 11.4577 3.63728 11.7552 4.3245C12.0526 5.01161 12.2013 5.74833 12.2013 6.53467C12.2013 7.321 12.0526 8.05772 11.7552 8.74483C11.4577 9.43206 11.0534 10.0312 10.5423 10.5423C10.0312 11.0534 9.43206 11.4577 8.74483 11.7552C8.05772 12.0526 7.321 12.2013 6.53467 12.2013ZM0.145 2.72183C0.0483334 2.62528 0 2.50817 0 2.3705C0 2.23294 0.0483334 2.11589 0.145 2.01933L2.01933 0.145C2.11167 0.0526669 2.22767 0.00544465 2.36733 0.00333354C2.50711 0.00111131 2.62528 0.0483335 2.72183 0.145C2.81839 0.241556 2.86667 0.358611 2.86667 0.496167C2.86667 0.633834 2.81839 0.750945 2.72183 0.847501L0.8475 2.72183C0.755167 2.81417 0.639167 2.86139 0.4995 2.8635C0.359722 2.86561 0.241556 2.81839 0.145 2.72183ZM12.9243 2.72183C12.8278 2.81839 12.7107 2.86667 12.5732 2.86667C12.4355 2.86667 12.3184 2.81839 12.2218 2.72183L10.3475 0.847501C10.2552 0.755167 10.2079 0.639167 10.2058 0.499501C10.2037 0.359723 10.2509 0.241556 10.3475 0.145C10.4441 0.0483335 10.5612 0 10.6988 0C10.8364 0 10.9534 0.0483335 11.05 0.145L12.9243 2.01933C13.0167 2.11167 13.0639 2.22767 13.066 2.36733C13.0682 2.50711 13.021 2.62528 12.9243 2.72183ZM6.53467 11.2013C7.83044 11.2013 8.93217 10.7475 9.83983 9.83983C10.7475 8.93217 11.2013 7.83044 11.2013 6.53467C11.2013 5.23889 10.7475 4.13717 9.83983 3.2295C8.93217 2.32183 7.83044 1.868 6.53467 1.868C5.23889 1.868 4.13717 2.32183 3.2295 3.2295C2.32183 4.13717 1.868 5.23889 1.868 6.53467C1.868 7.83044 2.32183 8.93217 3.2295 9.83983C4.13717 10.7475 5.23889 11.2013 6.53467 11.2013Z"
        fill="#BABABA"
      />
    </svg>
  );
}

export function MapPinIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <rect x="6.67383" y="3.52246" width="0.790393" height="9.59942" fill="#BABABA" />
      <rect
        width="0.790398"
        height="9.59934"
        transform="matrix(0.979748 0.200235 -0.200163 0.979763 4.44531 3.29785)"
        fill="#BABABA"
      />
      <rect
        x="0.689453"
        y="8.18164"
        width="0.79054"
        height="6.43605"
        transform="rotate(-90 0.689453 8.18164)"
        fill="#BABABA"
      />
      <rect
        x="3.6543"
        y="10.3545"
        width="0.79054"
        height="9.59763"
        transform="rotate(-90 3.6543 10.3545)"
        fill="#BABABA"
      />
      <path
        d="M7.25391 8.34961L6.67508 7.81129L8.06489 6.31632C8.21351 6.15645 8.46357 6.14736 8.62341 6.29601C8.78325 6.44466 8.79234 6.69476 8.64372 6.85463L7.25391 8.34961Z"
        fill="#BABABA"
      />
      <path
        d="M11.5 0C12.2394 8.13272e-05 12.8673 0.274687 13.3828 0.822266C13.8982 1.36986 14.1562 2.06541 14.1562 2.9082C14.1562 3.2478 14.0842 3.59502 13.9414 3.94922C13.7987 4.30331 13.6174 4.65311 13.3965 4.99805C13.1755 5.34315 12.9278 5.67406 12.6543 5.99121C12.3808 6.30848 12.1111 6.59785 11.8447 6.8584C11.797 6.90442 11.7423 6.93893 11.6816 6.96191C11.6211 6.98478 11.5605 6.99605 11.5 6.99609C11.4416 6.99609 11.3827 6.98621 11.3242 6.96582C11.2658 6.94546 11.2115 6.91213 11.1621 6.86621C10.8958 6.60568 10.6261 6.31489 10.3525 5.99512C10.079 5.67533 9.82986 5.34452 9.60645 5.00195C9.38314 4.65953 9.20033 4.30981 9.05762 3.95312C8.91486 3.5964 8.8438 3.2478 8.84375 2.9082C8.84375 2.06524 9.10155 1.36991 9.61719 0.822266C10.1328 0.274605 10.7605 0 11.5 0ZM11.499 1.70801C10.961 1.70801 10.5246 2.14453 10.5244 2.68262C10.5244 3.22088 10.9609 3.65723 11.499 3.65723C12.037 3.65706 12.4736 3.22078 12.4736 2.68262C12.4734 2.14463 12.0369 1.70817 11.499 1.70801Z"
        fill="#BABABA"
      />
      <path
        d="M7.94238 4.01074H0.978516V12.377H12.7588V7.1084H13.7383V12.6055C13.7383 13.02 13.4018 13.3564 12.9873 13.3564H0.75C0.335828 13.3561 0 13.0197 0 12.6055V3.78223C0.00038013 3.36829 0.336064 3.0326 0.75 3.03223H7.94238V4.01074Z"
        fill="#BABABA"
      />
      <ellipse cx="13.2496" cy="7.13639" rx="0.423425" ry="0.423504" fill="#BABABA" />
      <ellipse cx="7.94296" cy="3.52214" rx="0.423425" ry="0.423504" fill="#BABABA" />
    </svg>
  );
}

export function IconChevron({ className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className={className}>
      <path
        d="M9 18l6-6-6-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconArrow({ className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M5 12h14M13 6l6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Edit({ className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M4.5 17.6 14.8 7.3a1.05 1.05 0 0 1 1.48 0l2.42 2.42a1.05 1.05 0 0 1 0 1.48L8.1 21.6H4.5v-4z"
        fill="currentColor"
      />
      <path
        d="M15.95 6.15 17.7 4.4c.2-.2.52-.2.72 0l2.9 2.9c.2.2.2.52 0 .72l-1.75 1.75-3.62-3.62z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Trash({ className = 'h-6 w-6' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path d="M9.5 4h5l.5 1H19v2H5V5h4l.5-1z" fill="currentColor" />
      <path d="M7 8h10v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8z" fill="currentColor" />
    </svg>
  );
}

export function ExclamationCircleIcon({ className = 'h-6 w-6' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M12 7v7"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="17" r="1.2" fill="#fff" />
    </svg>
  );
}

export function Check({ className = 'h-5 w-5 text-[#0f1625]' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M4.5 12.5l4.5 4.5L19.5 6.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseRoundIcon({ className = 'h-6 w-6' }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

export function PenIcon({ className = 'h-6 w-6' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M3.096 16.6418C2.52383 16.6418 1.95808 16.5161 1.39875 16.2648C0.83925 16.0134 0.373 15.6775 0 15.257C0.382 15.148 0.7435 14.9163 1.0845 14.5618C1.4255 14.2074 1.596 13.7341 1.596 13.1418C1.596 12.4429 1.838 11.8516 2.322 11.3678C2.806 10.8838 3.39733 10.6418 4.096 10.6418C4.79483 10.6418 5.38617 10.8838 5.87 11.3678C6.354 11.8516 6.596 12.4429 6.596 13.1418C6.596 14.1043 6.25333 14.9282 5.568 15.6135C4.8825 16.299 4.0585 16.6418 3.096 16.6418ZM3.096 15.1418C3.646 15.1418 4.11683 14.9459 4.5085 14.5543C4.90017 14.1626 5.096 13.6918 5.096 13.1418C5.096 12.8584 5.00017 12.6209 4.8085 12.4293C4.61683 12.2376 4.37933 12.1418 4.096 12.1418C3.81267 12.1418 3.57517 12.2376 3.3835 12.4293C3.19183 12.6209 3.096 12.8584 3.096 13.1418C3.096 13.5251 3.05017 13.8751 2.9585 14.1918C2.86683 14.5084 2.746 14.8084 2.596 15.0918C2.67933 15.1251 2.76267 15.1418 2.846 15.1418H3.096ZM8.40375 11.084L6.173 8.85325L14.7383 0.288C14.9216 0.104667 15.1508 0.00883333 15.4258 0.0005C15.7008 -0.00783333 15.9383 0.088 16.1383 0.288L16.969 1.11875C17.169 1.31875 17.269 1.55208 17.269 1.81875C17.269 2.08542 17.169 2.31875 16.969 2.51875L8.40375 11.084Z"
        fill="#C4C4C4"
      />
    </svg>
  );
}

export function Clock({ className = 'h-6 w-6' }) {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2024 13.75C10.2822 13.75 8.65563 13.0836 7.32279 11.7508C5.99011 10.4181 5.32377 8.79152 5.32377 6.8711C5.32377 4.9652 5.99011 3.34354 7.32279 2.00612C8.65563 0.668708 10.2822 0 12.2024 0C14.1085 0 15.7302 0.668708 17.0674 2.00612C18.4048 3.34354 19.0735 4.9652 19.0735 6.8711C19.0735 8.79152 18.4048 10.4181 17.0674 11.7508C15.7302 13.0836 14.1085 13.75 12.2024 13.75ZM12.1985 12.375C13.7263 12.375 15.0249 11.8403 16.0944 10.7708C17.1638 9.70139 17.6985 8.40278 17.6985 6.875C17.6985 5.34722 17.1638 4.04861 16.0944 2.97917C15.0249 1.90972 13.7263 1.375 12.1985 1.375C10.6708 1.375 9.37215 1.90972 8.30271 2.97917C7.23326 4.04861 6.69854 5.34722 6.69854 6.875C6.69854 8.40278 7.23326 9.70139 8.30271 10.7708C9.37215 11.8403 10.6708 12.375 12.1985 12.375ZM12.886 6.60527V4.03677C12.886 3.84198 12.8201 3.67874 12.6883 3.54704C12.5566 3.4152 12.3933 3.34927 12.1983 3.34927C12.0034 3.34927 11.8401 3.4152 11.7086 3.54704C11.5769 3.67874 11.511 3.84198 11.511 4.03677V6.83627C11.511 6.94413 11.5334 7.04863 11.5782 7.14977C11.6228 7.25091 11.6841 7.34067 11.762 7.41904L13.8891 9.55442C14.0255 9.69665 14.1875 9.76777 14.3749 9.76777C14.5622 9.76777 14.727 9.69665 14.8693 9.55442C15.0115 9.41233 15.0826 9.24901 15.0826 9.06446C15.0826 8.8799 15.0115 8.71651 14.8693 8.57427L12.886 6.60527ZM1.60417 3.89583C1.40938 3.89583 1.24606 3.82991 1.11421 3.69806C0.982514 3.56622 0.916667 3.4029 0.916667 3.2081C0.916667 3.01316 0.982514 2.84992 1.11421 2.71838C1.24606 2.58668 1.40938 2.52083 1.60417 2.52083H3.7196C3.9144 2.52083 4.07764 2.58676 4.20933 2.7186C4.34118 2.85045 4.4071 3.01377 4.4071 3.20856C4.4071 3.40351 4.34118 3.56675 4.20933 3.69829C4.07764 3.82999 3.9144 3.89583 3.7196 3.89583H1.60417ZM0.6875 7.5625C0.492708 7.5625 0.329389 7.49658 0.197542 7.36473C0.0658473 7.23288 0 7.06956 0 6.87477C0 6.67983 0.0658473 6.51658 0.197542 6.38504C0.329389 6.25335 0.492708 6.1875 0.6875 6.1875H3.7196C3.9144 6.1875 4.07764 6.25342 4.20933 6.38527C4.34118 6.51712 4.4071 6.68044 4.4071 6.87523C4.4071 7.07017 4.34118 7.23342 4.20933 7.36496C4.07764 7.49665 3.9144 7.5625 3.7196 7.5625H0.6875ZM1.60417 11.2292C1.40938 11.2292 1.24606 11.1632 1.11421 11.0314C0.982514 10.8995 0.916667 10.7362 0.916667 10.5414C0.916667 10.3465 0.982514 10.1833 1.11421 10.0517C1.24606 9.92001 1.40938 9.85417 1.60417 9.85417H3.7196C3.9144 9.85417 4.07764 9.92009 4.20933 10.0519C4.34118 10.1838 4.4071 10.3471 4.4071 10.5419C4.4071 10.7368 4.34118 10.9001 4.20933 11.0316C4.07764 11.1633 3.9144 11.2292 3.7196 11.2292H1.60417Z"
        fill="#BABABA"
      />
    </svg>
  );
}

export function ChevronUp({ className = 'h-6 w-6' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M6 15l6-6 6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronDown({ className = 'h-6 w-6' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M6 9l6 6 6-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronUpDown({ className = 'h-8 w-5' }) {
  return (
    <svg viewBox="0 0 24 36" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M6 14l6-6 6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 24l6 6 6-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconPencil({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={className}>
      <path
        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Crosshair({ className = 'h-4 w-4' }) {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M9.45 19.65V18.6693C7.36667 18.4551 5.61283 17.6358 4.1885 16.2115C2.76417 14.7872 1.94492 13.0333 1.73075 10.95H0.75C0.5375 10.95 0.359417 10.8781 0.21575 10.7343C0.0719166 10.5904 0 10.4123 0 10.1998C0 9.98708 0.0719166 9.809 0.21575 9.6655C0.359417 9.52183 0.5375 9.45 0.75 9.45H1.73075C1.94492 7.36667 2.76417 5.61283 4.1885 4.1885C5.61283 2.76417 7.36667 1.94492 9.45 1.73075V0.75C9.45 0.5375 9.52192 0.359417 9.66575 0.21575C9.80958 0.0719168 9.98775 0 10.2003 0C10.4129 0 10.591 0.0719168 10.7345 0.21575C10.8782 0.359417 10.95 0.5375 10.95 0.75V1.73075C13.0333 1.94492 14.7872 2.76417 16.2115 4.1885C17.6358 5.61283 18.4551 7.36667 18.6693 9.45H19.65C19.8625 9.45 20.0406 9.52192 20.1843 9.66575C20.3281 9.80958 20.4 9.98775 20.4 10.2003C20.4 10.4129 20.3281 10.591 20.1843 10.7345C20.0406 10.8782 19.8625 10.95 19.65 10.95H18.6693C18.4551 13.0333 17.6358 14.7872 16.2115 16.2115C14.7872 17.6358 13.0333 18.4551 10.95 18.6693V19.65C10.95 19.8625 10.8781 20.0406 10.7343 20.1843C10.5904 20.3281 10.4123 20.4 10.1998 20.4C9.98708 20.4 9.809 20.3281 9.6655 20.1843C9.52183 20.0406 9.45 19.8625 9.45 19.65ZM10.2 17.2C12.1333 17.2 13.7833 16.5167 15.15 15.15C16.5167 13.7833 17.2 12.1333 17.2 10.2C17.2 8.26667 16.5167 6.61667 15.15 5.25C13.7833 3.88333 12.1333 3.2 10.2 3.2C8.26667 3.2 6.61667 3.88333 5.25 5.25C3.88333 6.61667 3.2 8.26667 3.2 10.2C3.2 12.1333 3.88333 13.7833 5.25 15.15C6.61667 16.5167 8.26667 17.2 10.2 17.2ZM10.2 13.7C9.2375 13.7 8.41358 13.3573 7.72825 12.6718C7.04275 11.9864 6.7 11.1625 6.7 10.2C6.7 9.2375 7.04275 8.41358 7.72825 7.72825C8.41358 7.04275 9.2375 6.7 10.2 6.7C11.1625 6.7 11.9864 7.04275 12.6718 7.72825C13.3573 8.41358 13.7 9.2375 13.7 10.2C13.7 11.1625 13.3573 11.9864 12.6718 12.6718C11.9864 13.3573 11.1625 13.7 10.2 13.7ZM10.2 12.2C10.75 12.2 11.2208 12.0042 11.6125 11.6125C12.0042 11.2208 12.2 10.75 12.2 10.2C12.2 9.65 12.0042 9.17917 11.6125 8.7875C11.2208 8.39583 10.75 8.2 10.2 8.2C9.65 8.2 9.17917 8.39583 8.7875 8.7875C8.39583 9.17917 8.2 9.65 8.2 10.2C8.2 10.75 8.39583 11.2208 8.7875 11.6125C9.17917 12.0042 9.65 12.2 10.2 12.2Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}
export function FilterIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="20"
      height="13"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M8.51978 12.448C8.27931 12.448 8.07778 12.3666 7.9152 12.2038C7.75244 12.041 7.67105 11.8394 7.67105 11.5989C7.67105 11.3583 7.75244 11.1568 7.9152 10.9944C8.07778 10.8318 8.27931 10.7505 8.51978 10.7505H10.7069C10.9474 10.7505 11.149 10.8319 11.3118 10.9947C11.4744 11.1574 11.5557 11.359 11.5557 11.5995C11.5557 11.8402 11.4744 12.0417 11.3118 12.2041C11.149 12.3667 10.9474 12.448 10.7069 12.448H8.51978ZM4.1347 7.0727C3.89423 7.0727 3.69271 6.99132 3.53013 6.82855C3.36755 6.66579 3.28626 6.46417 3.28626 6.2237C3.28626 5.98303 3.36755 5.78151 3.53013 5.61912C3.69271 5.45654 3.89423 5.37525 4.1347 5.37525H15.092C15.3325 5.37525 15.5341 5.45664 15.6969 5.6194C15.8595 5.78217 15.9407 5.98379 15.9407 6.22426C15.9407 6.46492 15.8595 6.66645 15.6969 6.82884C15.5341 6.99141 15.3325 7.0727 15.092 7.0727H4.1347ZM0.848724 1.69745C0.608253 1.69745 0.406728 1.61607 0.24415 1.4533C0.0813834 1.29053 0 1.08891 0 0.848441C0 0.607781 0.0813834 0.406256 0.24415 0.243867C0.406728 0.0812888 0.608253 0 0.848724 0H18.389C18.6295 0 18.831 0.0813834 18.9936 0.24415C19.1564 0.406916 19.2378 0.608536 19.2378 0.849008C19.2378 1.08967 19.1564 1.29119 18.9936 1.45358C18.831 1.61616 18.6295 1.69745 18.389 1.69745H0.848724Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DeleteIcon({ className = 'h-5 w-5' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#BABABA"
      className={className}
    >
      <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
    </svg>
  );
}

export function CloseIcon({ className = 'h-5 w-5' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#BABABA"
      className={className}
    >
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  );
}

export function PinCheck({ className = 'h-5 w-5' }) {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_6864_14112"
        masktype="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="20"
      >
        <rect width="17" height="20" fill="#BABABA" />
      </mask>
      <g mask="url(#mask0_6864_14112)">
        <path
          d="M7.76195 8.9776L6.87448 8.09013C6.72318 7.939 6.54621 7.86174 6.34358 7.85836C6.14094 7.85514 5.96075 7.9324 5.80301 8.09013C5.64544 8.24787 5.56666 8.42899 5.56666 8.63349C5.56666 8.83816 5.64544 9.01937 5.80301 9.17711L7.11871 10.5083C7.30255 10.6921 7.51696 10.7841 7.76195 10.7841C8.00695 10.7841 8.22136 10.6921 8.40519 10.5083L11.9065 7.00697C12.0577 6.85584 12.1348 6.67633 12.1381 6.46844C12.1413 6.26055 12.0641 6.07774 11.9065 5.92C11.7488 5.76243 11.5676 5.68365 11.3629 5.68365C11.1584 5.68365 10.9773 5.76243 10.8196 5.92L7.76195 8.9776ZM16.5025 8.37935C16.5025 9.19396 16.3314 10.0369 15.9893 10.9081C15.6473 11.7795 15.1843 12.6618 14.6004 13.5552C14.0164 14.4486 13.3269 15.3391 12.532 16.2265C11.737 17.1142 10.8833 17.9783 9.97097 18.8188C9.81069 18.9621 9.62991 19.0697 9.42863 19.1413C9.22717 19.213 9.02742 19.2488 8.82936 19.2488C8.63129 19.2488 8.43323 19.2147 8.23517 19.1464C8.03693 19.078 7.85768 18.9721 7.6974 18.8287C6.78519 17.988 5.93152 17.1222 5.13639 16.2314C4.34143 15.3407 3.65042 14.4502 3.06334 13.5601C2.4761 12.6699 2.01144 11.7876 1.66937 10.9132C1.32729 10.0386 1.15625 9.19396 1.15625 8.37935C1.15625 6.03343 1.91504 4.13422 3.43261 2.6817C4.95036 1.22919 6.74927 0.50293 8.82936 0.50293C10.9094 0.50293 12.7083 1.22919 14.2261 2.6817C15.7437 4.13422 16.5025 6.03343 16.5025 8.37935Z"
          fill="#B9B9B9"
        />
      </g>
    </svg>
  );
}

export function ProgressActivityIcon({ className = 'h-5 w-5' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#fff"
      className={className}
    >
      <path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z" />
    </svg>
  );
}

export function HistoryIcon({ className = 'h-5 w-5' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#000"
      className={className}
    >
      <path d="M480-120q-138 0-240.5-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z" />
    </svg>
  );
}

export function ArrowDown({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M6 9L1 4H11L6 9Z" fill="#989898" />
    </svg>
  );
}

export function WhereToVoteIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.9565 7.64179L5.15625 6.84154C5.01982 6.70526 4.86024 6.6356 4.67752 6.63254C4.4948 6.62964 4.33232 6.69931 4.19008 6.84154C4.048 6.98378 3.97696 7.1471 3.97696 7.3315C3.97696 7.51606 4.048 7.67945 4.19008 7.82169L5.37648 9.02206C5.54224 9.18783 5.73558 9.27071 5.9565 9.27071C6.17742 9.27071 6.37076 9.18783 6.53652 9.02206L9.69375 5.86483C9.83003 5.72856 9.89962 5.56669 9.90252 5.37923C9.90542 5.19177 9.83583 5.02692 9.69375 4.88469C9.55151 4.7426 9.38812 4.67156 9.20356 4.67156C9.01916 4.67156 8.85584 4.7426 8.7136 4.88469L5.9565 7.64179ZM13.838 7.10233C13.838 7.83689 13.6838 8.59696 13.3753 9.38254C13.0669 10.1683 12.6494 10.9639 12.1229 11.7695C11.5963 12.5751 10.9746 13.3781 10.2577 14.1783C9.5409 14.9787 8.77112 15.7579 7.94842 16.5158C7.80389 16.6451 7.64087 16.742 7.45937 16.8066C7.27772 16.8713 7.0976 16.9036 6.919 16.9036C6.7404 16.9036 6.56181 16.8728 6.38321 16.8112C6.20446 16.7495 6.04282 16.654 5.89829 16.5247C5.07574 15.7667 4.30597 14.986 3.58898 14.1827C2.87215 13.3795 2.24904 12.5766 1.71967 11.7739C1.19014 10.9712 0.771146 10.1756 0.462688 9.38713C0.154229 8.59849 0 7.83689 0 7.10233C0 4.98697 0.684215 3.27441 2.05265 1.96465C3.42123 0.654881 5.04335 0 6.919 0C8.79465 0 10.4168 0.654881 11.7854 1.96465C13.1538 3.27441 13.838 4.98697 13.838 7.10233Z"
        fill="white"
      />
    </svg>
  );
}

export function Instagram({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="5"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
      <circle cx="17" cy="7" r="1.5" fill="currentColor" />
    </svg>
  );
}

export function XIcon({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 19 18" className={className} fill="currentColor" aria-hidden="true">
      <path d="M14.8663 0H17.7607L11.4371 7.2275L18.8764 17.0625H13.0515L8.48925 11.0976L3.269 17.0625H0.37275L7.1365 9.33187L0 0H5.97275L10.0966 5.45213L14.8663 0ZM13.8504 15.33H15.4543L5.10125 1.6415H3.38013L13.8504 15.33Z" />
    </svg>
  );
}

export function Facebook({ className = 'h-4 w-4' }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TiktokIcon({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 23 23" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.5162 5.33043C18.3707 5.25521 18.229 5.17275 18.0917 5.08336C17.6925 4.81942 17.3264 4.50843 17.0015 4.15707C16.1884 3.22674 15.8847 2.28293 15.7729 1.62213H15.7774C15.6839 1.07363 15.7226 0.71875 15.7284 0.71875H12.025V15.0389C12.025 15.2312 12.025 15.4212 12.0169 15.609C12.0169 15.6324 12.0147 15.6539 12.0134 15.6791C12.0134 15.6894 12.0134 15.7002 12.0111 15.711C12.0111 15.7137 12.0111 15.7164 12.0111 15.7191C11.9721 16.2329 11.8074 16.7292 11.5315 17.1644C11.2556 17.5996 10.877 17.9604 10.429 18.2149C9.96201 18.4806 9.43389 18.6199 8.89667 18.6192C7.17122 18.6192 5.7728 17.2123 5.7728 15.4747C5.7728 13.7371 7.17122 12.3302 8.89667 12.3302C9.22329 12.3299 9.5479 12.3813 9.85845 12.4824L9.86294 8.7117C8.92019 8.58992 7.96244 8.66485 7.0501 8.93174C6.13776 9.19864 5.29063 9.65172 4.56216 10.2624C3.92385 10.817 3.38722 11.4788 2.97642 12.2179C2.82009 12.4874 2.23027 13.5704 2.15884 15.3282C2.11392 16.326 2.41355 17.3596 2.5564 17.7868V17.7958C2.64624 18.0474 2.99439 18.9058 3.56175 19.6295C4.01925 20.21 4.55977 20.72 5.16591 21.1429V21.1339L5.17489 21.1429C6.96773 22.3612 8.95552 22.2812 8.95552 22.2812C9.29962 22.2673 10.4523 22.2812 11.7613 21.6609C13.2132 20.9731 14.0398 19.9485 14.0398 19.9485C14.5678 19.3362 14.9877 18.6385 15.2814 17.8852C15.6165 17.0043 15.7284 15.9477 15.7284 15.5254V7.92826C15.7733 7.95521 16.3717 8.35098 16.3717 8.35098C16.3717 8.35098 17.2337 8.90352 18.5787 9.26334C19.5436 9.51939 20.8436 9.5733 20.8436 9.5733V5.89689C20.3881 5.94631 19.4632 5.80256 18.5162 5.33043Z" />
    </svg>
  );
}

export function DownloadIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        d="M8.7295 12.7003C8.58924 12.7003 8.45869 12.6778 8.33783 12.633C8.21698 12.5884 8.10204 12.5116 7.99302 12.4026L4.37377 8.78333C4.20073 8.6101 4.11528 8.40748 4.11741 8.17546C4.11974 7.94345 4.20519 7.73715 4.37377 7.55654C4.55437 7.37613 4.76175 7.28292 4.99589 7.27691C5.23023 7.2709 5.4377 7.35819 5.6183 7.53879L7.85655 9.77704V0.87295C7.85655 0.625226 7.94016 0.417852 8.10737 0.250827C8.2744 0.083609 8.48177 0 8.7295 0C8.97722 0 9.1846 0.083609 9.35162 0.250827C9.51884 0.417852 9.60245 0.625226 9.60245 0.87295V9.77704L11.8407 7.53879C12.0139 7.36576 12.2195 7.2803 12.4573 7.28244C12.6953 7.28477 12.9046 7.37613 13.0852 7.55654C13.2538 7.73715 13.3411 7.94161 13.3471 8.16994C13.3531 8.39826 13.2658 8.60273 13.0852 8.78333L9.46598 12.4026C9.35695 12.5116 9.24201 12.5884 9.12116 12.633C9.00031 12.6778 8.86975 12.7003 8.7295 12.7003ZM2.1041 17.459C1.51612 17.459 1.01844 17.2553 0.611065 16.8479C0.203688 16.4406 0 15.9429 0 15.3549V13.0718C0 12.8241 0.083609 12.6167 0.250827 12.4497C0.417852 12.2825 0.625226 12.1989 0.87295 12.1989C1.12067 12.1989 1.32805 12.2825 1.49507 12.4497C1.66229 12.6167 1.7459 12.8241 1.7459 13.0718V15.3549C1.7459 15.4445 1.78324 15.5266 1.85793 15.6011C1.93242 15.6758 2.01448 15.7131 2.1041 15.7131H15.3549C15.4445 15.7131 15.5266 15.6758 15.6011 15.6011C15.6758 15.5266 15.7131 15.4445 15.7131 15.3549V13.0718C15.7131 12.8241 15.7967 12.6167 15.9639 12.4497C16.1309 12.2825 16.3383 12.1989 16.586 12.1989C16.8338 12.1989 17.0411 12.2825 17.2082 12.4497C17.3754 12.6167 17.459 12.8241 17.459 13.0718V15.3549C17.459 15.9429 17.2553 16.4406 16.8479 16.8479C16.4406 17.2553 15.9429 17.459 15.3549 17.459H2.1041Z"
        fill="#626262"
      />
    </svg>
  );
}

// File type icons
export function PictureAsPdfIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z" />
    </svg>
  );
}

export function ImageIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
    </svg>
  );
}

export function WordIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
    </svg>
  );
}

export function ExcelIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
    </svg>
  );
}

export function DocIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
    </svg>
  );
}

export function HeartPOHIcon({ className = 'h-5.5 w-7.5', style = '' }) {
  return (
    <svg
      width="22"
      height="29"
      viewBox="0 0 22 29"
      className={className}
      style={style}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M18.6787 24.0127C20.2199 24.0127 21.5106 25.1804 21.6641 26.7139L21.8301 28.3789H0L0.166016 26.7139C0.319493 25.1805 1.61029 24.0128 3.15137 24.0127H18.6787ZM10.915 0C16.9433 0 21.831 4.88679 21.8311 10.915C21.8311 16.4993 17.6364 21.1 12.2266 21.748V24.0107H9.60645V21.748C4.19551 21.1011 0 16.5002 0 10.915C9.56311e-05 4.88694 4.88697 0.000237934 10.915 0ZM13.3203 7.8584C12.9587 7.85843 12.5684 7.95542 12.1494 8.14941C11.7303 8.34352 11.3267 8.7409 10.9385 9.34082C10.5502 8.7408 10.1457 8.34354 9.72656 8.14941C9.3076 7.95542 8.91731 7.85841 8.55566 7.8584C7.92918 7.8584 7.40159 8.07205 6.97363 8.5C6.54568 8.92795 6.33203 9.45554 6.33203 10.082C6.33204 10.9115 6.68716 11.7259 7.39746 12.5244C8.10772 13.3229 8.93487 14.1501 9.87891 15.0059L10.3955 15.4688C10.4661 15.5393 10.548 15.5926 10.6406 15.6279C10.7331 15.6631 10.8279 15.6807 10.9248 15.6807C11.0218 15.6807 11.1188 15.6632 11.2158 15.6279C11.3129 15.5926 11.3972 15.5393 11.4678 15.4688L11.9834 15.0059C12.857 14.2117 13.6689 13.406 14.4189 12.5898C15.1689 11.7737 15.5439 10.9379 15.5439 10.082C15.5439 9.45554 15.3303 8.92795 14.9023 8.5C14.4744 8.07209 13.9468 7.8584 13.3203 7.8584Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CrownIcon({ className = 'h-12 w-12' }) {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6.70624 15.6682C6.89984 14.9761 7.07606 14.3604 7.24415 13.7434C8.42546 9.41788 9.59866 5.09004 11.0014 0.829211C11.0373 0.719455 11.0733 0.610855 11.1162 0.50341C11.2321 0.212268 11.4384 0.0216398 11.7596 0.00199935C12.1039 -0.0199518 12.3856 0.139483 12.5004 0.449109C12.6684 0.905462 12.8168 1.37914 12.8968 1.85745C13.3385 4.47194 14.1361 6.98362 15.0392 9.46987C15.4588 10.624 15.7892 11.8094 16.1614 12.9809C16.1834 13.0514 16.217 13.1195 16.2692 13.2489C16.3596 13.0999 16.4303 12.9948 16.4883 12.8839C17.3601 11.2156 18.2145 9.53804 19.106 7.88015C19.5337 7.08529 20.0276 6.32739 20.4936 5.55333C20.7348 5.15358 21.0304 5.00455 21.3955 5.08773C21.7375 5.16514 21.9856 5.46437 21.9949 5.90917C22.0076 6.49376 21.9972 7.08066 21.9555 7.6641C21.6529 11.8106 21.3387 15.9547 21.0315 20.1012C21.0049 20.4605 20.9759 20.8128 21.093 21.1791C21.2414 21.6458 20.8321 22.2662 20.3105 22.3922C19.9499 22.48 19.5697 22.5065 19.1964 22.525C17.0807 22.6302 14.9627 22.6856 12.8505 22.8335C10.6652 22.986 8.48227 23.0415 6.2947 22.9675C5.27569 22.9329 4.2532 22.8762 3.24346 22.7422C2.73221 22.6741 2.22908 22.4499 1.75146 22.2327C1.30629 22.0317 1.10574 21.6285 1.07791 21.1363C0.995605 19.6899 0.90518 18.2446 0.817075 16.7992C0.704624 14.9692 0.616518 13.1369 0.469289 11.3091C0.359157 9.94124 0.172512 8.58027 0.017168 7.21699C-0.0280442 6.82418 -0.0106549 6.45563 0.406688 6.25576C0.749836 6.09171 1.14979 6.19684 1.46164 6.62662C1.84304 7.15229 2.20938 7.70223 2.49108 8.28567C3.09507 9.53457 3.80455 10.7153 4.54881 11.8845C5.23859 12.9693 5.82519 14.1189 6.45816 15.2384C6.52656 15.3597 6.59727 15.481 6.70508 15.6682H6.70624Z"
        fill="#F7CB30"
      />
    </svg>
  );
}

const HEART_PATH_D =
  'M60 108 C60 108 4 72 4 36 C4 14 20 4 36 4 C48 4 56 10 60 18 C64 10 72 4 84 4 C100 4 116 14 116 36 C116 72 60 108 60 108Z';

export function HeartIcons({ className = 'h-12 w-12', style }) {
  return (
    <svg
      viewBox="0 0 112 104"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <g transform="translate(-4 -4)">
        <path d={HEART_PATH_D} fill="currentColor" />
      </g>
    </svg>
  );
}

export function SearchGearIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M824-120 568-376q-12-13-25.5-26.5T516-428q38-24 61-64t23-88q0-75-52.5-127.5T420-760q-75 0-127.5 52.5T240-580q0 6 .5 11.5T242-557q-18 2-39.5 8T164-535q-2-11-3-22t-1-23q0-109 75.5-184.5T420-840q109 0 184.5 75.5T680-580q0 43-13.5 81.5T629-428l251 252-56 56ZM240-80l-12-60q-12-5-22.5-10.5T184-164l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T228-420l12-60h80l12 60q12 5 22.5 10.5T376-396l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T332-140l-12 60h-80Zm96.5-143.5Q360-247 360-280t-23.5-56.5Q313-360 280-360t-56.5 23.5Q200-313 200-280t23.5 56.5Q247-200 280-200t56.5-23.5Z" />
    </svg>
  );
}

export function AutoAwesomeMotionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-80q-33 0-56.5-23.5T400-160v-320q0-33 23.5-56.5T480-560h320q33 0 56.5 23.5T880-480v320q0 33-23.5 56.5T800-80H480Zm0-80h320v-320H480v320Zm-240-80v-400q0-33 23.5-56.5T320-720h400v80H320v400h-80ZM80-400v-400q0-33 23.5-56.5T160-880h400v80H160v400H80Zm400 240v-320 320Z" />
    </svg>
  );
}

export function ArticleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M280-280h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
    </svg>
  );
}

export function VolunteerActivismIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M640-440 474-602q-31-30-52.5-66.5T400-748q0-55 38.5-93.5T532-880q32 0 60 13.5t48 36.5q20-23 48-36.5t60-13.5q55 0 93.5 38.5T880-748q0 43-21 79.5T807-602L640-440Zm0-112 109-107q19-19 35-40.5t16-48.5q0-22-15-37t-37-15q-14 0-26.5 5.5T700-778l-60 72-60-72q-9-11-21.5-16.5T532-800q-22 0-37 15t-15 37q0 27 16 48.5t35 40.5l109 107ZM280-220l278 76 238-74q-5-9-14.5-15.5T760-240H558q-27 0-43-2t-33-8l-93-31 22-78 81 27q17 5 40 8t68 4q0-11-6.5-21T578-354l-234-86h-64v220ZM40-80v-440h304q7 0 14 1.5t13 3.5l235 87q33 12 53.5 42t20.5 66h80q50 0 85 33t35 87v40L560-60l-280-78v58H40Zm80-80h80v-280h-80v280Zm520-546Z" />
    </svg>
  );
}

export function PermMediaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M360-440h400L622-620l-92 120-62-80-108 140ZM120-120q-33 0-56.5-23.5T40-200v-520h80v520h680v80H120Zm160-160q-33 0-56.5-23.5T200-360v-440q0-33 23.5-56.5T280-880h200l80 80h280q33 0 56.5 23.5T920-720v360q0 33-23.5 56.5T840-280H280Zm0-80h560v-360H527l-80-80H280v440Zm0 0v-440 440Z" />
    </svg>
  );
}

export function PersonBookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-240q-56 0-107 17.5T280-170v10h400v-10q-42-35-93-52.5T480-240Zm129-59q60 21 111 59v-560H240v560q51-38 111-59t129-21q69 0 129 21ZM437.5-497.5Q420-515 420-540t17.5-42.5Q455-600 480-600t42.5 17.5Q540-565 540-540t-17.5 42.5Q505-480 480-480t-42.5-17.5ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80H240Zm339-361q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-99-99Z" />
    </svg>
  );
}

export function ContactMailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M560-520h280v-200H560v200Zm140-50-100-70v-40l100 70 100-70v40l-100 70ZM80-120q-33 0-56.5-23.5T0-200v-560q0-33 23.5-56.5T80-840h800q33 0 56.5 23.5T960-760v560q0 33-23.5 56.5T880-120H80Zm556-80h244v-560H80v560h4q42-75 116-117.5T360-360q86 0 160 42.5T636-200ZM445-435q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35ZM182-200h356q-34-38-80.5-59T360-280q-51 0-97 21t-81 59Zm149.5-291.5Q320-503 320-520t11.5-28.5Q343-560 360-560t28.5 11.5Q400-537 400-520t-11.5 28.5Q377-480 360-480t-28.5-11.5ZM480-480Z" />
    </svg>
  );
}
export function HeartCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M718-313 604-426l57-56 57 56 141-141 57 56-198 198ZM440-501Zm0 381L313-234q-72-65-123.5-116t-85-96q-33.5-45-49-87T40-621q0-94 63-156.5T260-840q52 0 99 22t81 62q34-40 81-62t99-22q81 0 136 45.5T831-680h-85q-18-40-53-60t-73-20q-51 0-88 27.5T463-660h-46q-31-45-70.5-72.5T260-760q-57 0-98.5 39.5T120-621q0 33 14 67t50 78.5q36 44.5 98 104T440-228q26-23 61-53t56-50l9 9 19.5 19.5L605-283l9 9q-22 20-56 49.5T498-172l-58 52Z" />
    </svg>
  );
}
